import React from 'react';
import KeycloakProvider from './components/KeycloakProvider/KeycloakProvider';
import { AppProvider } from './shared/AppProvider';

const App = () => (
  <KeycloakProvider>
    <AppProvider />
  </KeycloakProvider>
);

export default App;
